import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("创建付款账号")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改组")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")

import { computed, ref, Ref, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

import eptBtn from '@/components/ExportButton.vue'
import unmatched from './ViewsComponents/payAccount/Unmatched.vue'
import differenceVerified from './ViewsComponents/payAccount/DifferenceVerified.vue'
import verified from './ViewsComponents/payAccount/Verified.vue'
import assignCustomer from './ViewsComponents/payAccount/AssignCustomer.vue'

import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'GET/verification/accounts': fetchList,
  // 创建
  'POST/verification/accounts': createdAccountApi,
  // 删除
  'DELETE/verification/accounts': delAccountApi,
  // 编辑
  'PUT/verification/accounts': editAccountApi,
  // 导入->客户账号
  'POST/verification/accounts/import': verificationAccountsImportApi,
  // 客户账号导入模板下载
  'GET/verification/accounts/download': verificationAccountsDownloadApi,
  // 导出客户付款账号
  'GET/verification/accounts/export': verificationAccountsExportApi,
  // 导出错误客户信息
  'GET/verification/accounts/import/error': verificationAccountsImportErrorApi,
  // 获取组列表
  'GET/verification/accounts/groups': verificationAccountsGroupsApi,
  // 批量修改组
  'POST/verification/accounts/update_group': verificationAccountsUpdate_groupApi,
} = Api

const { 
  MI_height, MI_tableData, fetchData, page, size, 
  MI_total, MI_pageChange, MI_sizeChange, 
  MI_identify, MI_params, MI_modifyForm, 
} = new tbMix(fetchList)

const customerTb: any = ref()
let groupRows: any = ref([])
const handleGroupChange = (row: any)  => {
  groupRows.value = row
}

let gruopList = ref([])
onBeforeMount(() => {
  verificationAccountsGroupsApi().then((rep) => {
    gruopList.value = rep.map((_group: string) => {
      return { label: _group, id: _group, }
    })
  })
})

let searchConfig = ref([
  {
    label: '客户名称',
    value: '',
    upKey: 'name',
    props: {
      placeholder: "请输入客户名称"
    }
  },
  {
    type: "SELECT",
    label: "组",
    value: "",
    upKey: "group",
    options: gruopList,
    seleProps: { label: "label", valueName: "id",},
    props: { placeholder: "请选择组", clearable: true, 'allow-create': true },
  },
  {
    label: '收付方',
    value: '',
    upKey: 'costTo',
    props: {
      placeholder: "请输入收付方"
    }
  },

])

const filterChildren = (row: {children?: object[] | null  }): any => {
  if(row.children != null) {
    row.children.map(_chil=> {
      filterChildren(_chil)
    })
  } else {
    delete row.children
  }
}
const cpTableData = computed(() => {
  return MI_tableData.value.map((e: any, index: number) => {
    e.id = e.customerId + e.costTo
    e.level = 1
    filterChildren(e)
    return e
  })
})

//创建
const addFg = ref(false)
const addConfig = ref([
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId',
  },
  {
    label: '客户名称',
    value: '',
    upKey: 'customer',
  },
  {
    label: '收付方',
    value: '',
    upKey: 'costTo',
  },
  {
    label: '销售',
    value: '',
    upKey: 'saler',
  },
  /* {
    label: '组',
    value: '',
    upKey: 'group',
    props: {
      placeholder: "请输入组"
    }
  }, */
  {
    type: "SELECT",
    label: "组",
    value: "",
    upKey: "group",
    options: gruopList,
    seleProps: { label: "label", valueName: "id",},
    props: { placeholder: "请选择组", clearable: true, 'allow-create': true },
  },
])
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async (params: any) => {
    await createdAccountApi(params)
    ElMessage.success('创建成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 编辑
const editFg = ref(false)
const editConfig = ref([
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId',
  },
  {
    label: '客户名称',
    value: '',
    upKey: 'customer',
  },
  {
    label: '收付方',
    value: '',
    upKey: 'costTo',
  },
  {
    label: '销售',
    value: '',
    upKey: 'saler',
  },
  {
    label: '组',
    value: '',
    upKey: 'group',
    props: {
      placeholder: "请输入组"
    }
  },
])
const editHandle = (row: any) => {
  MI_modifyForm(row, editConfig, editFg, async (params: any) => {
    await editAccountApi({...params, id: row.id})
    ElMessage.success('编辑成功')
    editFg.value = false
    fetchData(MI_params)
  })
}

// 批量修改
const batchModifyFg = ref(false)
const batchModifyConfig = ref([
  {
    type: "SELECT",
    label: "组",
    value: "",
    upKey: "group",
    options: gruopList,
    seleProps: { label: "label", valueName: "id",},
    props: { placeholder: "请选择组", clearable: true, 'allow-create': true },
  },
])
const batchModifyHandle = () => {
  if(groupRows.value.length === 0){
    ElMessage.warning('请选择一条数据')
    return
  }
  MI_modifyForm({}, batchModifyConfig, batchModifyFg, async (params: any) => {
    let ids = groupRows.value.reduce((arr: any, e: any) => {
      if(e.level !== 1){
        arr.push(e.id)
      }
      return arr
    }, [])
    
    await verificationAccountsUpdate_groupApi({ ids, ...params })
    ElMessage.success('修改成功')
    batchModifyFg.value = false
    fetchData(MI_params)
  })

}


// 删除
const delHandle = async(row: any) => {
  await ElMessageBox.confirm(
    '确认删除',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  const formData = new FormData()
  formData.append('id', row.id)
  await delAccountApi(formData)
  ElMessage.success('删除成功')
  fetchData(MI_params)

}
// -------- 未匹配tab页面 ------------

/* const matchFg = ref<boolean>(false)
let originRows = ref<any[]>([])
let matchRows: any = ref([])
const matchHandle = async (rows: {id: string}[], resetFn: () => void) => {
  if(rows.length != 1){
    ElMessage.warning('请选择一条数据')
    return
  }
  originRows.value = rows
  matchRows.value = await verificationApi({id: rows[0].id})
  matchFg.value = true
  // resetFn()
}



const matchSelection = ref<object[]>([])
const handleMatchChange = (val: object[]) => {
  // 多选处理
  matchSelection.value = val
}


const autoMatch = async () => {
  // 自动匹配
  if(matchSelection.value.length != 1){
    ElMessage.warning('请选择一条数据')
    return
  }
  await verifyIdPostApi({...matchSelection.value[0], id: originRows.value[0].id })
  ElMessage.success('匹配成功')
  matchFg.value = false
  matchSelection.value = []
}
const handleMatch = async () =>{
  matchRows.value = await verificationHandleApi()
} */

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "收款台账" }, {
          default: _withCtx(() => [
            _createVNode(unmatched)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "客户付款账号管理",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "搜索" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FlexibleForm, _mergeProps({
                initSearch: true,
                title: true,
                searchConfig: _unref(searchConfig)
              }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle())),
              class: "mb-10 mt-10"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })), [
              [_directive_permission, 'Create']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
              upText: '导入客户账号',
              upFetch: _unref(verificationAccountsImportApi),
              upParams: {},
              showBtn: true
            }, {
              default: _withCtx(() => [
                _createVNode(eptBtn, {
                  type: "primary",
                  exportFn: _unref(verificationAccountsDownloadApi),
                  exportText: '下载导入客户账号模板',
                  isDirect: true
                }, null, 8, ["exportFn"])
              ]),
              _: 1
            }, 8, ["upFetch"])), [
              [_directive_permission, 'Create']
            ]),
            _createVNode(eptBtn, {
              type: "primary",
              exportFn: _unref(verificationAccountsExportApi),
              exportText: '导出客户付款账号'
            }, null, 8, ["exportFn"]),
            _createVNode(eptBtn, {
              type: "danger",
              exportFn: _unref(verificationAccountsImportErrorApi),
              exportText: '导出错误客户付款账号'
            }, null, 8, ["exportFn"]),
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (batchModifyHandle()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref_key: "customerTb",
              ref: customerTb,
              border: "",
              data: _unref(cpTableData),
              "row-key": "id",
              onSelectionChange: handleGroupChange,
              "max-height": _unref(MI_height) - 90 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50"
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户ID",
                  prop: "customerId",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  prop: "customer",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "收付方",
                  prop: "costTo"
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售",
                  prop: "saler"
                }),
                _createVNode(_component_el_table_column, {
                  label: "组",
                  prop: "group"
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行名称汇总",
                  prop: "bankNames",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({ row }) => [
                    (!row.level)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                                onClick: ($event: any) => (editHandle(row)),
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_permission, 'Write']
                              ]),
                              _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                                type: "danger",
                                onClick: ($event: any) => (delHandle(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_permission, 'Delete']
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              class: "mt-10",
              "page-sizes": [10, 30, 50, 100, 200, 500],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "分配客户",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(assignCustomer)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "创建",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: editConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量修改组",
      modelValue: batchModifyFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((batchModifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (batchModifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: batchModifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})